<template>
  <div class="manage-menu" id="menu">
    <div class="manage-menu_item" v-for="(item,index) in menus" :key="index">
      <div class="manage-menu_name manage-menu_name-active" @click="menuChildChange(index)">
        <i :class="item.icon"></i>
        <span class="text-size">{{item.name}}</span>
        <i
          :class="[item.rotate?'el-icon-arrow-down icon-chevron-down-outline go':'el-icon-arrow-down icon-chevron-down-outline aa']"
        ></i>
      </div>
      <div v-if="item.rotate" class="manage-menu_child">
        <div
          class="manage-menu_child_item"
          @click="urlChange(items.url)"
          v-for="(items,indexs) in item.resources"
          :key="indexs"
        >
          <span
            :class="routerUrl === items.url?'manage-menu_child_item_hover manage-menu_active':'manage-menu_child_item_hover'"
          >{{items.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "child",
  props: ["menus"],
  data() {
    return {
      menuList: [],
      routerUrl: null
    };
  },
  created() {},
  methods() {},
  watch: {
    menus: function(n, old) {
      this.menus.forEach(element => {
        this.$set(element, "rotate", false);
      });
      this.menus.forEach((e,index) => {
        for (let indexs in e.resources) {
          if (this.routerUrl == e.resources[indexs].url) {
            this.$set(this.menus[index], "rotate", !this.menus[index].rotate);
          }
        }
      });
    },
    $route: function(to, from) {
      this.$nextTick(function() {
        this.$set(this, "routerUrl", to.fullPath);
      });
    }
  },
  mounted() {
    this.$set(this, "routerUrl", localStorage.getItem("lastRouter"));
  },
  methods: {
    menuChildChange(index) {
      // this.menus[index].rotate = !this.menus[index].rotate;
      this.$set(this.menus[index], "rotate", !this.menus[index].rotate);
    },
    urlChange(url) {
      this.$router.push({ path: url });
    }
  },
  computed: {}
};
</script>
<style lang="less" rel="stylesheet/less">
#menu {
  width: 100%;
  height: calc(100% - 93.6px);
  background: rgb(52,64,88);
  width: 200px;
  overflow: auto;
}
.manage-menu {
}
.manage-menu_item {
  margin-bottom: 10px;
}
.manage-menu_name {
  position: relative;
  background: rgb(52,64,88);
  color: #fff;
  opacity: 0.8;
  font-size: 14px;
  height: 33.6px;
  line-height: 33.6px;
  padding-left: 20px;
  cursor: pointer;
}
.manage-menu_name:hover {
  background: rgb(57, 66, 82);
}
.go {
  transform: rotate(-180deg);
  transition: all 0.5s;
}
.aa {
  transition: all 0.5s;
}
.icon-chevron-down-outline {
  position: absolute;
  top: 50%;
  right: 15px;
  height: 20px;
  line-height: 20px;
  margin-top: -10px;
  font-size: 14px;
  cursor: pointer;
}
.manage-menu_child {
  display: flex;
  padding: 5px 20px;
  background: #242e40;
  color: #fff;
  flex-wrap: wrap;
}
.manage-menu_child_item {
  width: 50%;
  height: 22px;
  line-height: 22px;
  margin: 8px 0 2px;
  cursor: pointer;
}
.manage-menu_active {
  color: #292b33 !important;
  background: #fff !important;
  font-weight: 500;
  opacity: 1 !important;
  border-radius: 2px;
  padding: 4 4px !important;
  height: 22px;
  line-height: 22px;
}
.manage-menu_child_item_hover {
  padding: 4 4px !important;
  display: block;
  width: auto;
  text-align: center;
  opacity: 0.8;
}
.manage-menu_child_item_hover:hover {
  display: block;
  background: rgb(57, 66, 82);
  color: #fff;
  font-weight: 500;
  opacity: 1;
  border-radius: 2px;
  padding: 4 4px !important;
  height: 22px;
  line-height: 22px;
}
.text-size {
  font-size: 14px;
  margin-left: 10px;
}
// .plus-icon-enter-active {
//   // transition: opacity 0.5s;
// }
// .plus-icon-enter {
//   // opacity: 0;
//   animation: mymove 0.5s infinite;
// }
// .plus-icon-leave-active {
//   // transition: opacity 0.5s;
// }
// .plus-icon-leave-to {
//   // opacity: 0;
//   animation: mymove 0.5s infinite;
// }
// @keyframes mymove
// {
// from {left:0px;}
// to {left:200px;}
// }

// @-webkit-keyframes mymove /*Safari and Chrome*/
// {
// from {top:0px;}
// to {left:200px;}
// }
</style>


// WEBPACK FOOTER //
// src/components/common/submenu.vue